import React from 'react'
import Carrot from './../../assets/img/carrot.jpg';
import Peas from './../../assets/img/peas.jpg';
import Palak from './../../assets/img/palak.jpg';
import Methi from './../../assets/img/methi.gif';
import Radish from './../../assets/img/radish.jpg';
import Turnip from './../../assets/img/turnip.jpg';
import Coriander from './../../assets/img/coriender.jpg';
import Onion from './../../assets/img/onion.jpg';
import Tomato from './../../assets/img/tomato.jpg';
import BitterGourd from './../../assets/img/bittergourd.jpg';
import Capsicum from './../../assets/img/capsicum.jpg';
import Potato from './../../assets/img/potato.jpg';
const RabiVeg = () => {
  return (
    <div className="container my-3">

    <div className="abouts">
        <h5>Rabi Crops Vegetables</h5>
    </div>

    <div className="about-box p-4 rounded shadow-lg" style={{textAlign:'justify'}}>

        <div className="row mb-1 justify-content-between">
            

            <div className="col-lg-12 mb-1">
                <h4>Peas</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Peas} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4">
                
                <p>Arkel Lincon, Boanvilla, Jawahar, E-6 & Azad</p>
                </div>

            </div>
            </div>

            <div className="col-lg-12 mb-1">
                <h4>Carrot</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Carrot} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>Pusa-Kesar, Nantes</p>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Palak</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Palak} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>All Green</p>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Methi</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Methi} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>Pusa Early, Bunching, Pusa Kasuri, PEB</p>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Radish</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Radish} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>Pusa Rashmi, Jap. White, R.R.W.T, Pusa Himani, Pusa Chetki</p>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Turnip</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Turnip} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>P. Swarnima, P. Chandernima, W-4</p>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Coriander</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Coriander} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>DH-5</p>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Onion</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Onion} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>Pusa Red, Pusa Ratnar, N-63, HS-2</p>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Tomato</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Tomato} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>Pusa Ruby, P Early, Dwarl, Sioux, Manglobe, Roma, P. Chuhhara, HS-102, Hisar Arun</p>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Bitter Gourd</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={BitterGourd} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>C-96, Pusa-Domausmi, Coimbatore Long</p>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Capsicum</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Capsicum} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>California wonder</p>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Potato</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Potato} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>Kufri Alankar, K. Chandermukhi, K. Sundhuri, K. Jyoti, K.Badshah, K.Pukhraj, K.Satluj, K.Bahar, K.ChipSona I & II</p>
                </div>

            </div>
            </div>
           

            
        </div>

        </div>
    </div>
  )
}

export default RabiVeg
